import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let frontmatter = {
  "title": "0.3.0-beta",
  "description": "Lanzamiento inicial de Orkestria."
};
export let structuredData = {
  "contents": [{
    "heading": "resumen",
    "content": "Lanzamiento inicial de **Orkestria** — el sistema operativo para restaurantes que integra operación, cocina, caja, inventario, reservas y reportes en una sola plataforma, con un asistente IA que te ayuda a hacer todo más rápido."
  }, {
    "heading": "cuenta-y-restaurantes",
    "content": "**Registro e inicio de sesión** con verificación por correo."
  }, {
    "heading": "cuenta-y-restaurantes",
    "content": "**Múltiples restaurantes por usuario**: forma parte de varios negocios desde una misma cuenta."
  }, {
    "heading": "cuenta-y-restaurantes",
    "content": "**Roles especializados**: dueño, administrador, mesero, chef, cajero, encargado de domicilios y encargado de inventario. Cada rol ve solo lo que necesita."
  }, {
    "heading": "cuenta-y-restaurantes",
    "content": "**Invitaciones por correo** para sumar miembros al equipo."
  }, {
    "heading": "información-del-restaurante",
    "content": "Datos básicos, branding y multimedia."
  }, {
    "heading": "información-del-restaurante",
    "content": "**Preferencias por restaurante**: moneda contable, umbral de stock bajo, sistema de crédito (fiado), orden de bloques en cocina, activación de carta digital pública."
  }, {
    "heading": "salón",
    "content": "**Gestión de mesas físicas** con áreas."
  }, {
    "heading": "salón",
    "content": "**Reservas** con calendario, asignación de clientes por día y estados (pendiente, confirmada, cumplida, no asistió)."
  }, {
    "heading": "pedidos",
    "content": "**Tomar pedido en mesa** con selección de productos, adiciones, combos y descuentos del día."
  }, {
    "heading": "pedidos",
    "content": "**Tomar domicilios** con datos del cliente, dirección y método de pago."
  }, {
    "heading": "pedidos",
    "content": "**Corregir pedido en curso**: editar cantidades, marcar productos para eliminar y avisar a cocina automáticamente."
  }, {
    "heading": "pedidos",
    "content": "**Entregas**: pedidos delivery listos para repartir."
  }, {
    "heading": "pedidos",
    "content": "**Órdenes completadas**: historial con factura para reimpresión."
  }, {
    "heading": "cocina",
    "content": "**Pantalla operativa para chefs** con bloques: nuevos, en preparación, listos para mesero, listos para domicilio."
  }, {
    "heading": "cocina",
    "content": "**Reordenamiento manual** de los bloques según el flujo del restaurante."
  }, {
    "heading": "cocina",
    "content": "**Avisos sonoros** cuando llegan pedidos nuevos."
  }, {
    "heading": "cocina",
    "content": "**Alertas de tiempo**: si un pedido lleva demasiado en preparación, el sistema lo destaca."
  }, {
    "heading": "caja",
    "content": "**Cobrar orden de mesa** con efectivo, transferencia, crédito (fiado) o combinación."
  }, {
    "heading": "caja",
    "content": "**Cobrar domicilios** con métodos equivalentes."
  }, {
    "heading": "caja",
    "content": "**Apertura y cierre de caja** con conteo de billetes y cuadre del día."
  }, {
    "heading": "caja",
    "content": "**Múltiples cajas registradoras** asignables a cajeros."
  }, {
    "heading": "caja",
    "content": "**Intermediarios**: bancos y wallets para registrar transferencias entrantes."
  }, {
    "heading": "caja",
    "content": "**Cuentas de crédito** (fiado): asigna saldo a clientes con límite configurable y registra pagos parciales."
  }, {
    "heading": "productos-y-menú",
    "content": "**Catálogo de productos** con categorías, fotos, precios y tipo (preparado, bajo pedido o combo)."
  }, {
    "heading": "productos-y-menú",
    "content": "**Adiciones** configurables para personalizar pedidos."
  }, {
    "heading": "productos-y-menú",
    "content": "**Horario semanal**: disponibilidad por día y promociones programadas."
  }, {
    "heading": "productos-y-menú",
    "content": "**Carta digital pública**: enlace público para que los clientes vean la carta."
  }, {
    "heading": "productos-y-menú",
    "content": "**Constructor visual** para reordenar categorías y productos arrastrando."
  }, {
    "heading": "inventario",
    "content": "**Seguimiento de stock opcional** por producto."
  }, {
    "heading": "inventario",
    "content": "**Movimientos automáticos** al confirmar pedidos."
  }, {
    "heading": "inventario",
    "content": "**Umbral de alerta** personalizable: el sistema avisa cuando un producto está por agotarse."
  }, {
    "heading": "clientes",
    "content": "**Directorio de clientes** con historial de pedidos."
  }, {
    "heading": "clientes",
    "content": "**Cuentas de crédito** por cliente con saldo y pagos."
  }, {
    "heading": "personal",
    "content": "**Lista de miembros** con sus roles."
  }, {
    "heading": "personal",
    "content": "**Cambio de rol** y desactivación de miembros."
  }, {
    "heading": "personal",
    "content": "**Invitaciones pendientes** con reenvío y cancelación."
  }, {
    "heading": "asistente-faki-ia",
    "content": "**Chat integrado** que entiende el contexto del restaurante."
  }, {
    "heading": "asistente-faki-ia",
    "content": "**Acciones automáticas**: Faki puede crear productos, categorías, clientes, reservas y más siguiendo tus instrucciones."
  }, {
    "heading": "asistente-faki-ia",
    "content": "**Guía visual**: Faki resalta los elementos y te lleva paso a paso cuando lo necesitas."
  }, {
    "heading": "asistente-faki-ia",
    "content": "**Lleva al lugar exacto** cuando termina una acción, para que veas el resultado."
  }, {
    "heading": "reportes-y-analítica",
    "content": "**Dashboard analítico** con KPIs operativos."
  }, {
    "heading": "reportes-y-analítica",
    "content": "**Reportes detallados** de ventas, productos, mesas, cocina, caja, domicilios, stock, personal, reservas y clientes."
  }, {
    "heading": "planes-y-facturación",
    "content": "**Suscripciones por restaurante** con plan asignable."
  }, {
    "heading": "planes-y-facturación",
    "content": "**Pagos y facturación** registrados en el sistema."
  }, {
    "heading": "gestión-interna-de-planes",
    "content": "Creación y edición de planes globales con features asignables."
  }, {
    "heading": "gestión-interna-de-planes",
    "content": "Asignación manual de suscripciones a restaurantes."
  }, {
    "heading": "gestión-interna-de-planes",
    "content": "Panel de auditoría con trazabilidad de acciones críticas (invitaciones, cambios de rol, pagos)."
  }, {
    "heading": "gestión-interna-de-planes",
    "content": "Gestión de cuotas de IA por restaurante y por rol."
  }, {
    "heading": "apariencia",
    "content": "**Temas claro, oscuro y noche** con preferencia guardada."
  }, {
    "heading": "apariencia",
    "content": "**Diseño responsive** para computador, tablet y celular."
  }],
  "headings": [{
    "id": "resumen",
    "content": "Resumen"
  }, {
    "id": "cuenta-y-restaurantes",
    "content": "Cuenta y restaurantes"
  }, {
    "id": "información-del-restaurante",
    "content": "Información del restaurante"
  }, {
    "id": "salón",
    "content": "Salón"
  }, {
    "id": "pedidos",
    "content": "Pedidos"
  }, {
    "id": "cocina",
    "content": "Cocina"
  }, {
    "id": "caja",
    "content": "Caja"
  }, {
    "id": "productos-y-menú",
    "content": "Productos y menú"
  }, {
    "id": "inventario",
    "content": "Inventario"
  }, {
    "id": "clientes",
    "content": "Clientes"
  }, {
    "id": "personal",
    "content": "Personal"
  }, {
    "id": "asistente-faki-ia",
    "content": "Asistente Faki (IA)"
  }, {
    "id": "reportes-y-analítica",
    "content": "Reportes y analítica"
  }, {
    "id": "planes-y-facturación",
    "content": "Planes y facturación"
  }, {
    "id": "gestión-interna-de-planes",
    "content": "Gestión interna de planes"
  }, {
    "id": "apariencia",
    "content": "Apariencia"
  }]
};
import {ChangelogHeader} from "@/components/docs/ChangelogHeader";
import {AdminOnly} from "@/components/docs/AdminOnly";
export let toc = [{
  depth: 2,
  url: "#resumen",
  title: _jsx(_Fragment, {
    children: "Resumen"
  })
}, {
  depth: 2,
  url: "#cuenta-y-restaurantes",
  title: _jsx(_Fragment, {
    children: "Cuenta y restaurantes"
  })
}, {
  depth: 2,
  url: "#información-del-restaurante",
  title: _jsx(_Fragment, {
    children: "Información del restaurante"
  })
}, {
  depth: 2,
  url: "#salón",
  title: _jsx(_Fragment, {
    children: "Salón"
  })
}, {
  depth: 2,
  url: "#pedidos",
  title: _jsx(_Fragment, {
    children: "Pedidos"
  })
}, {
  depth: 2,
  url: "#cocina",
  title: _jsx(_Fragment, {
    children: "Cocina"
  })
}, {
  depth: 2,
  url: "#caja",
  title: _jsx(_Fragment, {
    children: "Caja"
  })
}, {
  depth: 2,
  url: "#productos-y-menú",
  title: _jsx(_Fragment, {
    children: "Productos y menú"
  })
}, {
  depth: 2,
  url: "#inventario",
  title: _jsx(_Fragment, {
    children: "Inventario"
  })
}, {
  depth: 2,
  url: "#clientes",
  title: _jsx(_Fragment, {
    children: "Clientes"
  })
}, {
  depth: 2,
  url: "#personal",
  title: _jsx(_Fragment, {
    children: "Personal"
  })
}, {
  depth: 2,
  url: "#asistente-faki-ia",
  title: _jsx(_Fragment, {
    children: "Asistente Faki (IA)"
  })
}, {
  depth: 2,
  url: "#reportes-y-analítica",
  title: _jsx(_Fragment, {
    children: "Reportes y analítica"
  })
}, {
  depth: 2,
  url: "#planes-y-facturación",
  title: _jsx(_Fragment, {
    children: "Planes y facturación"
  })
}, {
  depth: 3,
  url: "#gestión-interna-de-planes",
  title: _jsx(_Fragment, {
    children: "Gestión interna de planes"
  })
}, {
  depth: 2,
  url: "#apariencia",
  title: _jsx(_Fragment, {
    children: "Apariencia"
  })
}];
function _createMdxContent(props) {
  const _components = {
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(ChangelogHeader, {
      version: "0.3.0-beta",
      date: "2026-04-25",
      tag: "Inicial"
    }), "\n", _jsx(_components.h2, {
      id: "resumen",
      children: "Resumen"
    }), "\n", _jsxs(_components.p, {
      children: ["Lanzamiento inicial de ", _jsx(_components.strong, {
        children: "Orkestria"
      }), " — el sistema operativo para restaurantes que integra operación, cocina, caja, inventario, reservas y reportes en una sola plataforma, con un asistente IA que te ayuda a hacer todo más rápido."]
    }), "\n", _jsx(_components.h2, {
      id: "cuenta-y-restaurantes",
      children: "Cuenta y restaurantes"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Registro e inicio de sesión"
        }), " con verificación por correo."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Múltiples restaurantes por usuario"
        }), ": forma parte de varios negocios desde una misma cuenta."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Roles especializados"
        }), ": dueño, administrador, mesero, chef, cajero, encargado de domicilios y encargado de inventario. Cada rol ve solo lo que necesita."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Invitaciones por correo"
        }), " para sumar miembros al equipo."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "información-del-restaurante",
      children: "Información del restaurante"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Datos básicos, branding y multimedia."
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Preferencias por restaurante"
        }), ": moneda contable, umbral de stock bajo, sistema de crédito (fiado), orden de bloques en cocina, activación de carta digital pública."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "salón",
      children: "Salón"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Gestión de mesas físicas"
        }), " con áreas."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Reservas"
        }), " con calendario, asignación de clientes por día y estados (pendiente, confirmada, cumplida, no asistió)."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "pedidos",
      children: "Pedidos"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Tomar pedido en mesa"
        }), " con selección de productos, adiciones, combos y descuentos del día."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Tomar domicilios"
        }), " con datos del cliente, dirección y método de pago."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Corregir pedido en curso"
        }), ": editar cantidades, marcar productos para eliminar y avisar a cocina automáticamente."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Entregas"
        }), ": pedidos delivery listos para repartir."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Órdenes completadas"
        }), ": historial con factura para reimpresión."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "cocina",
      children: "Cocina"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Pantalla operativa para chefs"
        }), " con bloques: nuevos, en preparación, listos para mesero, listos para domicilio."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Reordenamiento manual"
        }), " de los bloques según el flujo del restaurante."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Avisos sonoros"
        }), " cuando llegan pedidos nuevos."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Alertas de tiempo"
        }), ": si un pedido lleva demasiado en preparación, el sistema lo destaca."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "caja",
      children: "Caja"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Cobrar orden de mesa"
        }), " con efectivo, transferencia, crédito (fiado) o combinación."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Cobrar domicilios"
        }), " con métodos equivalentes."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Apertura y cierre de caja"
        }), " con conteo de billetes y cuadre del día."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Múltiples cajas registradoras"
        }), " asignables a cajeros."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Intermediarios"
        }), ": bancos y wallets para registrar transferencias entrantes."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Cuentas de crédito"
        }), " (fiado): asigna saldo a clientes con límite configurable y registra pagos parciales."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "productos-y-menú",
      children: "Productos y menú"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Catálogo de productos"
        }), " con categorías, fotos, precios y tipo (preparado, bajo pedido o combo)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Adiciones"
        }), " configurables para personalizar pedidos."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Horario semanal"
        }), ": disponibilidad por día y promociones programadas."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Carta digital pública"
        }), ": enlace público para que los clientes vean la carta."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Constructor visual"
        }), " para reordenar categorías y productos arrastrando."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "inventario",
      children: "Inventario"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Seguimiento de stock opcional"
        }), " por producto."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Movimientos automáticos"
        }), " al confirmar pedidos."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Umbral de alerta"
        }), " personalizable: el sistema avisa cuando un producto está por agotarse."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "clientes",
      children: "Clientes"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Directorio de clientes"
        }), " con historial de pedidos."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Cuentas de crédito"
        }), " por cliente con saldo y pagos."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "personal",
      children: "Personal"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Lista de miembros"
        }), " con sus roles."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Cambio de rol"
        }), " y desactivación de miembros."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Invitaciones pendientes"
        }), " con reenvío y cancelación."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "asistente-faki-ia",
      children: "Asistente Faki (IA)"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Chat integrado"
        }), " que entiende el contexto del restaurante."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Acciones automáticas"
        }), ": Faki puede crear productos, categorías, clientes, reservas y más siguiendo tus instrucciones."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Guía visual"
        }), ": Faki resalta los elementos y te lleva paso a paso cuando lo necesitas."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Lleva al lugar exacto"
        }), " cuando termina una acción, para que veas el resultado."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "reportes-y-analítica",
      children: "Reportes y analítica"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Dashboard analítico"
        }), " con KPIs operativos."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Reportes detallados"
        }), " de ventas, productos, mesas, cocina, caja, domicilios, stock, personal, reservas y clientes."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "planes-y-facturación",
      children: "Planes y facturación"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Suscripciones por restaurante"
        }), " con plan asignable."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Pagos y facturación"
        }), " registrados en el sistema."]
      }), "\n"]
    }), "\n", _jsxs(AdminOnly, {
      children: [_jsx(_components.h3, {
        id: "gestión-interna-de-planes",
        children: "Gestión interna de planes"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Creación y edición de planes globales con features asignables."
        }), "\n", _jsx(_components.li, {
          children: "Asignación manual de suscripciones a restaurantes."
        }), "\n", _jsx(_components.li, {
          children: "Panel de auditoría con trazabilidad de acciones críticas (invitaciones, cambios de rol, pagos)."
        }), "\n", _jsx(_components.li, {
          children: "Gestión de cuotas de IA por restaurante y por rol."
        }), "\n"]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "apariencia",
      children: "Apariencia"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Temas claro, oscuro y noche"
        }), " con preferencia guardada."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Diseño responsive"
        }), " para computador, tablet y celular."]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
